import React from 'react'
import NavLinks from './NavLinks'
import './menu.css'
import { MdArrowOutward } from 'react-icons/md'

export const MenuOverlay = ({ links, close }) => {
  return (
    <ul className=' flex flex-col py-6 px-6 h-[calc(100vh-68px)] bg-cream text-maroon border-t border-ink/10'>
      {links.map((link, index) => (
        <li key={index} onClick={close} className=' menu-items border-b border-ink/10 py-5 font-display text-4xl tracking-tight'>
          <NavLinks href={link.path} name={link.name} />
        </li>
      ))}
      <a href='mailto:info@wilsontomisin.com' onClick={close} className=' mt-8 flex items-center justify-between gap-2 bg-maroon text-cream font-medium px-6 py-4 rounded-full shrink-0'>
        Hire Me
        <MdArrowOutward />
      </a>
    </ul>
  )
}
